export default function React_ES6_Variables() {
  return (
    <div>
      <h1>React_ES6_Variables Component</h1>
      <p>This is the React_ES6_Variables tutorial page.</p>
    </div>
  );
}
